import './assets/css/ui-shared.css';
import './assets/css/ui.css';
import './assets/css/a11y.css';

window.VAE = window.VAE || {};

import './src/config.js';
import './src/content-hasher.js';
import './src/state-manager.js';
import './src/ui-shared.js';
import './src/dom.js';
import './src/api.js';
import './src/axe-integration.js';
import './src/text.js';
import './src/colors.js';
import './src/motion.js';
import './src/language.js';
import './src/profiles.js';
import './src/ui.js';
import './src/core.js';
import './src/analysis-display.js';
import './src/hybrid-test.js';
import './src/consistency-tester.js';
import './src/version-manager.js';

document.addEventListener('DOMContentLoaded', () => {
  if (window.VAE) {
    // Check if this is a test environment (optional check since window.vaeConfig may not exist)
    if (
      window.vaeConfig?.client?.environment === 'test'
    ) {
      import('./src/testing.js')
        .then(() => {
          console.log('VAE Testing module loaded.');
          VAE.UI.createWidget();
          VAE.Core.init();
          VAE.VersionManager.init();
        })
        .catch((err) => {
          console.error('Error loading VAE Testing module:', err);
        });
    } else {
      VAE.UI.createWidget();
      VAE.Core.init();
      VAE.VersionManager.init();
    }
  } else {
    console.error('VAE Initialization failed: VAE namespace not available.');
  }
});
